import { createContext, useContext } from 'react'
import type { ConnectivityState, OutboxOperation } from './types'

export interface OfflineContextValue {
  connectivity: ConnectivityState
  syncing: boolean
  pendingCount: number
  attentionCount: number
  pendingOperations: OutboxOperation[]
  lastSyncAt: string | null
  offlineReady: boolean
  updateAvailable: boolean
  hasActiveDraft: boolean
  syncNow: () => Promise<void>
  retryPending: () => Promise<void>
  applyUpdate: () => Promise<void>
  setDraftActive: (draftKey: string, active: boolean) => void
}

export const OfflineContext = createContext<OfflineContextValue | null>(null)

export function useOffline(): OfflineContextValue {
  const context = useContext(OfflineContext)
  if (!context) throw new Error('useOffline deve ser usado dentro de OfflineProvider.')
  return context
}
